import React, { Component } from 'react';
import api from '../../api/';
import ParadigmaTable from "../../components/ParadigmaTable/"
import 'react-datetime/css/react-datetime.css';
import dateFunctions from '../functions/dateFunctions';
import DateFilter from '../../components/ParadigmaTable/DateFilter';
import Modal from './Modal';

class Convenios extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: [],
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    show: false,
                    private: true,
                    filterable: false,
                },
                {
                    Header: "Titulo",
                    id: "titulo",
                    accessor: "titulo",
                    show: true,
                    filterable: true,
                },
                // {
                //     Header: "Contraparte",
                //     id: "empresa",
                //     accessor: "empresa",
                //     show: true,
                //     filterable: true,
                // },
                {
                    Header: "Dependencia",
                    id: "dependencia",
                    accessor: "dependencia",
                    show: true,
                    filterable: true,
                    width: 50,
                },
                {
                    Header: "Tipo",
                    id: "tipo",
                    accesor: "tipo",
                    Cell: d => d.original.tipo,
                    // Cell: d => console.log(d.original),//d.original.tipo_convenio ? d.original.tipo_convenio.nombre : '',
                    show: true,
                    filterable: true,
                    width: 100,
                },
                {
                    Header: "Proyecto",
                    id: "solicitud",
                    Cell: (c) => c.original.solicitud ? c.original.solicitud : '',
                    show: true,
                    width: 500,
                },
                {
                    Header: "Fecha Inicio",
                    id: "fecha_inicio",
                    width: 170,
                    className: "text-center",
                    accessor: d => dateFunctions.parseDate(d.fecha_inicio),
                    show: true,
                    filterable: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Fecha Vencimiento",
                    id: "fecha_vencimiento",
                    width: 170,
                    className: "text-center",
                    accessor: d => dateFunctions.parseDate(d.fecha_vencimiento),
                    show: true,
                    filterable: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
            ]
        };
    }

    render() {
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        permission: 'convenios_create',
                        component: (props) => <Modal {...props} action="CREATE"/>
                    },
                    {
                        edit: true,
                        permission: 'convenios_edit',
                        component: (props) => <Modal {...props} action="EDIT"/>
                    },
                    {
                        detail: true,
                        permission: 'convenios_view',
                        component: (props) => <Modal {...props} action="DETAIL"/>
                    },
                    {
                        edit: true,
                        permission: 'convenios_delete',
                        component: (props) => <Modal {...props} action="DELETE"/>
                    },
                ]}
                outerFilter={this.state.filter}
                apiUrl={api.convenios.convenios.list}
                columns={this.state.columns}
                title={"Convenios"}
            />
        );
    }
}

export default Convenios;



// WEBPACK FOOTER //
// ./src/views/Convenios/Convenios.js